import React from 'react'
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import "../../../components/layout/style.css"
import Layout from '../../../components/layout';

function NoToken() {
    return (
        <Layout>
            <HighlightOffIcon className="icon" />
            <Layout.Title>Token has expired or does not exists!</Layout.Title>
            <Layout.Paragraph>Please resend email confirmation!</Layout.Paragraph>
        </Layout>
    )
}

export default NoToken
